<template>
    <iframe :src="`https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${place}`" frameborder="0"></iframe>
</template>

<script>
export default {
    props: {
        apiKey: {
            type: String,
            required: true
        },
        address: {
            type: String,
            required: true
        }
    },
    computed: {
        place() {
            return encodeURI(this.address);
        }
    }
}
</script>